import type { TeamMembership } from '@rhythmic/db/prisma-js'
import type { DeleteTeamMembershipPayload } from '@rhythmic/types'
import { DeleteTeamMembershipSchema } from '@rhythmic/types'
import type { Transaction } from '@tanstack/vue-db'
import { useRhythmicLogger } from '#imports'

import { getTeamMembershipCollection } from '../../getCollections'

const logger = useRhythmicLogger('useTeamContext:deleteTeamMembership')

export interface DeleteTeamMembershipContext {
  teamId: string
}

export default function handleDeleteTeamMembership(
  payload: DeleteTeamMembershipPayload,
  context: DeleteTeamMembershipContext,
): Transaction<TeamMembership> | undefined {
  try {
    const parsed = DeleteTeamMembershipSchema.parse(payload)
    const { teamId } = context

    if (!teamId) {
      const error = new Error('Team context is not ready')
      logger.error('Unable to delete team membership: missing team identifier')
      throw error
    }

    if (parsed.team_id !== teamId) {
      const error = new Error('Payload team identifier does not match active team context')
      logger.error('Unable to delete team membership: mismatched team identifier', {
        payloadTeamId: parsed.team_id,
        contextTeamId: teamId,
      })
      throw error
    }

    const collection = getTeamMembershipCollection(teamId)
    return collection.delete(parsed.user_id)
  } catch (error) {
    logger.error('deleteTeamMembership failed', { payload, error })
    if (error instanceof Error) throw error
    throw new Error('Failed to delete team membership')
  }
}
